<template>
  <v-app>
    <AppMain />
    <TheNotification />
  </v-app>
</template>

<script lang="ts" setup>
import TheNotification from "@/components/TheNotification.vue";
import AppMain from "@/components/AppMain.vue";
</script>
<style>
a {
  color: #0069a2;
  text-decoration: none;
}

a:hover {
  color: #20a6e3;
}

/* truncate table feature - single line view toggle */
.truncate-enabled .enable-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.truncate-enabled .enable-truncate.line-clamp {
  white-space: normal;
  -webkit-line-clamp: 1;
}
</style>
